<template>
    <header :class="['order-header', {'order-header--fullscreen': fullscreen, 'order-header--is-mobile': isMobile}]">
        <div class="order-header-title">
            <div v-if="isMobile && ['3-digital', '3-default', '3-digital-variants', '3-digital-bulk-prices', '3-default-variants', '3-default-bulk-prices','3-digital-more-photos', '3-default-more-photos'].includes(orderStep)" class="variants-product">
                <template v-if="['3-digital', '3-default'].includes(orderStep)">
                    <div :class="['variants-product-img', {'variants-product-img--no-img': !product.images.length}]" :style="!!product.images.length ? `background-image: url(${_.first(product.images).thumb})` : ''"></div>
                </template>
                <template v-else>
                    <div :class="['variants-product-img', {'variants-product-img--no-img': !productItem.images.length}]" :style="!!productItem.images.length ? `background-image: url(${_.first(productItem.images).thumb})` : ''"></div>
                </template>
                <div class="variants-product-info">
                    <template v-if="['3-digital', '3-default'].includes(orderStep)">
                        <div class="variants-product-title">{{ $t('products') }}</div>
                        <div class="variants-product-subtitle">{{ product.name }}</div>
                    </template>
                    <template v-else-if="['3-digital-variants', '3-default-variants'].includes(orderStep)">
                        <div class="variants-product-title">{{ $t('choose_variant') }}</div>
                        <div class="variants-product-subtitle">{{ product.name }}, {{ productItem.name }}</div>
                    </template>
                    <template v-else>
                        <template v-if="['3-digital-more-photos', '3-default-more-photos'].includes(orderStep)">
                            <div class="variants-product-title">{{ $t('choose_more_photos') }}</div>
                        </template>
                        <template v-else>
                            <div class="variants-product-title">{{ $t('choose_bulk_price') }}</div>
                        </template>
                        <div class="variants-product-subtitle">{{ product.name }}, {{ productItem.name }}, {{ variant.name }}</div>
                    </template>
                </div>
            </div>
            <template v-else-if="!fullscreen">{{ title }}</template>
        </div>
        <div v-if="!isMobile" class="order-header-info">
            <span v-if="!fullscreen" v-html="info"></span>
        </div>
        <div class="order-header-actions">
            <template v-if="carouselView && ['3-digital-more-photos', '3-default-more-photos'].includes(this.orderStep)">
                <a href="#" id="block-view"
                   @click.prevent="$store.dispatch('SET_CAROUSEL_VIEW', null)">
                    <span class="material-icon icon-view_comfortable"></span>
                </a>
                <b-tooltip placement="bottom" target="block-view">
                    {{ $t('helpers.block_view') }}
                </b-tooltip>
            </template>
            <a href="#"
               :style="{opacity: [1, '3-digital-more-photos', '3-default-more-photos'].indexOf(orderStep) >= 0 ? 1 : 0}"
               id="order-header-fullscreen"
               @click.prevent="$emit('handle-fullscreen', !fullscreen)">
                <span class="material-icon" :class="fullscreen ? 'icon-fullscreen_exit' : 'icon-fullscreen'"></span>
            </a>
            <b-tooltip v-if="!fullscreen" placement="bottom" target="order-header-fullscreen">
                {{ $t('helpers.fullscreen') }}
            </b-tooltip>
            <template v-if="!isMobile">
                <a href="#" id="order-header-close" @click.prevent="$emit('close-order')">
                    <span class="material-icon icon-clear"></span>
                </a>
                <b-tooltip placement="bottom" target="order-header-close">
                    {{ $t('helpers.close') }}
                </b-tooltip>
            </template>
        </div>
    </header>
</template>

<script>
  import orderHeader from 'src/mixins/orderHeaderComponent';

  export default {
    mixins: [orderHeader],
  };
</script>
